import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../store/loaderSlice";
import LUPA from "../img/lupa_404.png";
import { footerActions } from "../store/footerSlice";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import CustomButton from "../shared/CustomButton";
import useBrazeScreenView from "../hooks/useBrazeScreenView";

const NotFoundPage = () => {
  useBrazeScreenView();
  const languageContext = useContext(LanguageContext);
  const isError = useSelector((state) => state.error.isError);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isError) {
      dispatch(loaderActions.loaderHide());
    }
  }, [isError]);

  useEffect(() => {
    dispatch(footerActions.setIsShow(false));
  }, []);

  return (
    <div className="container error_page">
      <div className="error_page_container">
        <div className="error_page_txt">
          <h3>
            {languageContext.getTranslation(appConst.NOT_FOUND_PAGE_TITLE)}
          </h3>
          <p>
            {languageContext.getTranslation(appConst.NOT_FOUND_PAGE_CONTENT)}
          </p>
        </div>
        <img
          src={LUPA}
          style={{ width: "100%", height: "auto" }}
        />
      </div>
      <div className="next_btn">
        <CustomButton
          nextPage={appConst.LUPA_SITE}
          background={appConst.LUPA_GREEN_COLOR}
          color={appConst.LUPA_ENABLE_FONT_COLOR}
          variant="contained"
          btnText={languageContext.getTranslation(appConst.TO_LUPA_SITE)}
          redirect={true}
          data-testid="not-found-next-button"
        ></CustomButton>
      </div>
    </div>
  );
};

export default NotFoundPage;
